import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage.js";
import { Origin } from "../todo-list.types.js";
const defaultFilterState = {
  todo: true,
  done: true,
  recall: true,
  ...Object.values(Origin).reduce(
    (acc, value) => ({
      ...acc,
      [value]: value !== Origin.MANUAL
    }),
    {}
  )
};
const FilterContext = createContext(void 0);
const useFilters = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilters must be used within a FilterProvider");
  }
  return context;
};
const FilterProvider = ({ children }) => {
  const [filters, setLocalStorageFilters] = useLocalStorage("filters", defaultFilterState);
  const setFilters = (value) => {
    setLocalStorageFilters((prevFilters) => {
      const newFilters = typeof value === "function" ? value(prevFilters ?? defaultFilterState) : value;
      return newFilters;
    });
  };
  return /* @__PURE__ */ jsx(FilterContext.Provider, { value: { filters, setFilters }, children });
};
export {
  FilterProvider,
  useFilters
};
